//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ItemCard from "~/components/gallery/ItemCard";
import { debounce } from '~/utils/utils';
const imagesLoaded = require('imagesloaded');
export default {
  components: {
    ItemCard
  },
  props: {
    pictures: {
      type: Array,
      default: () => []
    },
    dark: {
      type: Boolean,
      default: false
    },
    lightBrownBg: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    window.addEventListener("resize", this.resizeAllGridItems);
    this.resizeAllGridItems();

    const allItems = document.getElementsByClassName("picture-card");
    for (let x = 0; x < allItems.length; x++) {
      imagesLoaded(allItems[x], this.resizeInstance);
      let node = allItems[x].querySelector('.image-item');
      if (!!node) {
        node.onload = () => {
          this.resizeGridItem(allItems[x]);
          this.$emit('loaded')
        }
      }
    }
    if (allItems.length) {
      imagesLoaded(this.$refs.galleryList, (instance) => {
        this.$emit('loaded')
      });
    } else {
      this.$emit('loaded')
    }
  },
  beforeDestroy () {
    window.removeEventListener("resize", this.resizeAllGridItems);
  },
  methods: {
    resizeGridItem(item) {
      const grid = document.querySelector(".personal-gallery-list");
      if (!grid) return
      const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
      // const rowSpan = Math.ceil((item.querySelector('.picture-content').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap));
      const rowSpan = Math.ceil(item.querySelector('.picture-content').offsetHeight / rowHeight);
      item.style.gridRowEnd = `span ${rowSpan}`;
    },

    resizeAllGridItems: debounce(function() {
      let allItems = document.getElementsByClassName("picture-card");
      for (let x = 0; x < allItems.length; x++) {
        this.resizeGridItem(allItems[x]);
        imagesLoaded( allItems[x], this.resizeInstance);
      }
    }, 50),

    resizeInstance(instance) {
      const item = instance.elements[0];
      this.resizeGridItem(item);
    }
  }

}
